import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import cardBg from '../../assets/images/card_bg.png';

const StyledContainer = styled.div`
	width: 360px;
	display: flex;
	flex-direction: column;
	gap: 30px;
	background-color: rgba(0, 0, 0, 0.25);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;
	background-image: url(${cardBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 30px 30px 0;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledBalanceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 11px;
	padding: 0 30px;

	img {
		opacity: 0.5;
	}

	${Text} {
		font-weight: 500;
		font-size: 26px;
		color: #ffffff;
	}
`;

const StyledBottomContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	gap: 10px;
	height: 60px;
	padding: 0 30px;
	background-color: rgba(255, 255, 255, 0.05);
	border-top: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}
`;

const StyledCopyButton = styled.div`
	height: 14px;
	opacity: 0.5;
	transition: opacity 0.3s ease;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledCardNumberContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;

	&:hover {
		${Text} {
			opacity: 1;
		}

		${StyledCopyButton} {
			opacity: 1;
		}
	}
`;

export {
	StyledBalanceContainer,
	StyledBottomContainer,
	StyledCardNumberContainer,
	StyledContainer,
	StyledCopyButton,
	StyledTopContainer,
};
